import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import server from './module/server'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    subLinks_1: 'https://5106962345563729.cn-qingdao.fc.aliyuncs.com/2016-08-15/proxy/sub.LATEST/s1',
    subLinks_2: 'https://5106962345563729.cn-zhangjiakou.fc.aliyuncs.com/2016-08-15/proxy/sub.LATEST/s1',
    modals: {
      modal_text: '',
      type: 'warning',
      modal: false
    }
  },
  getters: {
    getModalsInfo: state => {
      return state.modals
    }
  },
  mutations: {
    setModalsInfo(state, modals) {
      state.modals.modal = modals.modal
      state.modals.type = modals.type || 'warning'
      state.modals.modal_text = modals.modal_text
    }
  },
  actions: {
    //
  },
  modules: {
    user,
    app,
    server
  }
})
